import { storeLocatorApiClient } from './index'

const basePath = 'shops/'

const getPath = ({ country = 'Nederland', city, postalcode, distance = 20 }) => {
  let path = `${basePath}country/${country}/`

  if (city) {
    path = `${path}city/${city}/`
  } else if (postalcode) {
    path = `${path}postalcode/${postalcode}/`
  } else {
    console.error('Postcode or city required to get store locations from api')
  }
  if (distance) {
    path = `${path}distance/${distance}`
  }
  return path
}

export default {
  async getStoreLocations(params) {
    return await storeLocatorApiClient.get(getPath(params))
  }
}
